import _ from 'underscore';
import Promise from 'bluebird';
import imageRepository from '@bingads-webui-campaign-legacy/adextension-shared/service/image-repository';
import imageAspectRatios from '@bingads-webui-campaign-legacy/adextension-shared/imageAspectRatios';

class SharedDataModelConverter {
  getImagesFromIdsAsync(imageIds) {
    return imageRepository.getImagesByIdsAsync(imageIds).then((returnedImages) => {
      const images = _.map(returnedImages, (returnedImage) => {
        return {
          Asset: returnedImage,
          AssetType: imageAspectRatios.imageTypeToEnum[returnedImage.Type],
        };
      });

      return images;
    });
  }

  convertToImageAsset(mtImage) {
    const sourceY = Math.floor((mtImage.Asset.Height - (100 * mtImage.Asset.Width / 133)) / 2);
    const subType = mtImage.Asset.Type === 'Image12x10' ? 'ImageMedia133X100' : mtImage.Asset.SubType;

    return {
      Asset: {
        '@odata.type': '#Model.ImageAsset',
        Id: mtImage.Asset.Id,
        IdString: mtImage.Asset.IdString,
        SubType: subType,
        CropX: 0,
        CropY: sourceY,
        CropHeight: mtImage.Asset.Height,
        CropWidth: mtImage.Asset.Width,
        ImageUrl: mtImage.Asset.OriginalUrl,
        OriginalWidth: mtImage.Asset.OriginalWidth,
        OriginalHeight: mtImage.Asset.OriginalHeight,
        Width: mtImage.Asset.Width,
        Height: mtImage.Asset.Height,
      },
    };
  }

  migrateLegacyImageAdExtension(extension) {
    return this.getImagesFromIdsAsync(extension.ImageIdsStr).then((images) => {
      extension.Images = _.map(images, (image) => this.convertToImageAsset(image));

      return extension;
    });
  }

  migrateLegacyDataAsync(data) {
    if (!_.isArray(data)) {
      return data;
    }

    const taskToProcess = [];

    _.each(data, (item) => {
      if (item.Images.length === 0 && item.ImageIdsStr.length > 0) {
        taskToProcess.push(this.migrateLegacyImageAdExtension(item));
      }
    });

    // eslint-disable-next-line no-restricted-globals
    return Promise.all(taskToProcess).then(() => data);
  }
}

const dataModelUtil = new SharedDataModelConverter();

export default dataModelUtil;
